var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "User, Profile, Add",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11620",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11621",
    d: "M14.817 4.167a3.984 3.984 0 11-5.634 0 3.984 3.984 0 015.634 0",
    fill: "none",
    stroke: "#13910a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11622",
    d: "M12 14.008c4.554 0 9 1.967 9 4.992v1a1 1 0 01-1 1H4a1 1 0 01-1-1v-1c0-3.026 4.446-4.992 9-4.992",
    fill: "none",
    stroke: "#13910a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11623",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgStep2;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Americo/icons/step_2.svg
// module id = 7624
// module chunks = 13